<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('rechargeMenu.rechargePrice')" prop="rechargePrice" >
        <a-input-number :min="0" :step="0.01" :precision="2" v-model="form.rechargePrice"  style="width: 100%" :placeholder="$t('rechargeMenu.inputRechargePrice')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('rechargeMenu.rechargeDiamond')" prop="rechargeDiamond" >
        <a-input-number :min="1" :step="1"  v-model="form.rechargeDiamond"  style="width: 100%" :placeholder="$t('rechargeMenu.inputRechargeDiamond')" />
      </a-form-model-item>
<!--      <a-form-model-item label="优惠百分比%" prop="preferential" >-->
<!--        <a-input-number :min="0" :max="100" v-model="form.preferential" placeholder="请输入优惠百分比%" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('rechargeMenu.giveDiamond')" prop="giveDiamond" >
        <a-input-number :min="0" :step="1" v-model="form.giveDiamond"  style="width: 100%" :placeholder="$t('rechargeMenu.inputGiveDiamond')"  />
      </a-form-model-item>
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入备注"  />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="英文备注" prop="remarkEn" >-->
<!--        <a-input  v-model="form.remarkEn" placeholder="请输入英文备注"  />-->
<!--      </a-form-model-item>-->

<!--      <a-form-model-item label="ios内购产品ID" prop="productId" >-->
<!--        <a-input v-model="form.productId" placeholder="请输入ios内购产品ID"  />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getRechargeMenu, addRechargeMenu, updateRechargeMenu } from '@/api/rechargeMenu/rechargeMenu.js'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',

      // 表单参数
      form: {
        id: null,

        rechargePrice: null,

        rechargeDiamond: null,

        productId: null,

        createTime: null,

        remark: null,
        remarkEn: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    rules() {
      return {
        rechargePrice: [
          { required: true, message: this.$t('rechargeMenu.rechargePriceRequired') }
        ],
        rechargeDiamond: [
          { required: true, message: this.$t('rechargeMenu.rechargeDiamondRequired') }
        ],
        giveDiamond: [
          { required: true, message: this.$t('rechargeMenu.giveDiamondRequired') }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        rechargePrice: null,
        rechargeDiamond: null,
        productId: null,
        createTime: null,
        remark: null,
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('common.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRechargeMenu({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('common.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateRechargeMenu(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addRechargeMenu(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
